var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-other-service" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                                "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                            "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                            "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                            "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                            "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 col-lg-4" }, [
          _c("div", { staticClass: "service-item" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [
              _vm._v(
                "In addition to the price you pay for the electricity you use, you must pay a so-called network fee."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "service-link" }, [
              _c("a", { staticClass: "return_link", attrs: { href: "#" } }, [
                _vm._v("See more\n                            "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "8",
                      height: "12",
                      viewBox: "0 0 8 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z",
                        fill: "#1B98BE",
                        stroke: "#1B98BE",
                        "stroke-width": "0.2"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "title" }, [
        _c(
          "h3",
          { staticClass: "h1 p-title p-black p-center mb-0 relawayBold" },
          [_vm._v("Our other services")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service-title" }, [
      _c("p", { staticClass: "relawaySM p-black med" }, [
        _c("b", [_vm._v("Some service name")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }